// ABOUTME: Maps the stable error codes a message status carries to what the user reads.
// ABOUTME: The code is the server's contract; the text is ours, in the user's language.

// A status error is a code, never a sentence: a line shown to one user must
// not be able to carry another user's data. Codes the turn itself reports get
// their own line; anything else is an error class and reads as the generic one.
const STATUS_ERROR_KEYS: Record<string, string> = {
  processing_interrupted: "chat.statusErrors.processingInterrupted",
}

export const statusErrorText = (code: string | null | undefined, t: (key: string) => string): string =>
  t((code && STATUS_ERROR_KEYS[code]) || "chat.errorOccurred")
